import { createSlice } from '@reduxjs/toolkit'
import baseReducers from 'apiV2/store/base/reducers'
import baseInitialState from 'apiV2/store/base/initialState'

import { indexLegalAgreements } from './asyncActions'

const legalAgreementSlice = createSlice({
  name: 'legalAgreement',
  initialState: baseInitialState,
  reducers: baseReducers,
  extraReducers: {
    [indexLegalAgreements.fulfilled](state, action) {
      state.records = action.payload
    },
  },
})

export default legalAgreementSlice
